import CircularProgress from '@material-ui/core/CircularProgress';
import type { PostData } from '@mogul/api-client';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { updatesApi } from '../../../api';
import { BackHeader } from '../../../components/common/backheader/BackHeader.component';
import { PostListing } from '../../../components/post-listing/PostListing.component';
import styles from './UpdatesPage.module.css';

const PageFooter = () => {
  const endMessage =
    "you've reached the end. Check your notifications for new community messages";
  return <div className={styles.postsFooter}>{endMessage}</div>;
};

interface State {
  updates: PostData[];
  totalCount: number;
  offset: number;
  loading: boolean;
}

export const UpdatesPage = () => {
  const history = useHistory();

  const [{ offset, loading, updates: posts, totalCount }, setState] =
    useState<State>({
      updates: [],
      totalCount: 1,
      loading: true,
      offset: 0,
    });

  React.useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop ===
        document.scrollingElement?.scrollHeight
      ) {
        setState(state => ({ ...state, offset: state.updates.length }));
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      setState(state => ({ ...state, loading: true }));

      const { data, meta } = (
        await updatesApi.listUpdates({ limit: 10, offset })
      ).data;

      setState(state => ({
        ...state,
        updates: [...state.updates, ...data],
        totalCount: meta.totalCount,
        loading: false,
      }));
    };

    void fetchEvents();
  }, [offset]);

  return (
    <div className={styles.postsPage}>
      <BackHeader
        title={'Updates'}
        headerOnPress={() => history.push('/platform/community-dashboard')}
      />
      {posts.map(post => {
        return (
          <div key={post.id} className={styles.postListingItem}>
            <PostListing post={post} />
          </div>
        );
      })}
      {loading && (
        <div className={styles.loaderContainer}>
          <CircularProgress />
        </div>
      )}
      {posts.length >= totalCount && <PageFooter />}
    </div>
  );
};
